import React from 'react'
import PropTypes from 'prop-types'
import { path, pathOr } from 'ramda'

import RatingsReasonsTooltip from '../ratings-tooltip'
import ComingSoonBadge from '../coming-soon-badge'
import { LeavingSoonTitle } from '../leaving-soon-title'
import { Rating } from '../../rating'
import { E2E_SELECTORS } from '../../../e2e-selectors'
import { getContentParentalRatingDisplay } from '../../../lib/utils'
import styles from './show-page-status.css'

// Renders badges plus the rating, coming-soon, and leaving-soon status states for show pages.
function ShowPageStatus({
  contentItem,
  badges
}) {
  const rating = getContentParentalRatingDisplay(contentItem)
  const reason = pathOr('', ['rating', 'reason'], contentItem)
  const advisories = pathOr('', ['rating', 'advisories'], contentItem)
  const isCVODRating = contentItem.rating?.ratingSystem === 'CVOD'
  const seasonIsComingSoon = path(['seasons', 0, 'isComingSoon'], contentItem)
  const seasonStartDate = contentItem?.seasons?.[0]?.start
  let comingSoonStartDate = null

  if (contentItem.isComingSoon && contentItem.start) {
    // if series isComingSoon = true, display COMING SOON and use series start as Available date
    comingSoonStartDate = contentItem.start
  } else if (
    /*
      if total season is 1, and season isComingSoon = true,
      display COMING SOON and use season start as Available date
    */
    contentItem.seasons?.length === 1 &&
    seasonIsComingSoon
  ) {
    comingSoonStartDate = seasonStartDate
  }

  const badgeContent = badges.filter(item => item)
    .map(badge => <div key={badge} className={styles.badge}>{badge}</div>)

  return (
    <>
      {/* Displays the CVOD rating plus badges. */}
      <div className={styles.badgesContainer}>
        {rating && isCVODRating ? (
          <Rating
            rating={contentItem.rating}
            className={styles.ratingLabel}
          />
        ) : null}
        {badgeContent}
      </div>

      {/* Displays the BSV rating when it is not a CVOD rating. */}
      <div className={styles.subHeader}>
        {rating && !isCVODRating ? (
          <RatingsReasonsTooltip reason={reason}>
            <span
              className={styles.rating}
              data-lbx-e2e={E2E_SELECTORS.RATING}
            >
              {`${rating} ${advisories}`}
            </span>
          </RatingsReasonsTooltip>
        ) : null}
      </div>

      {/* Displays the coming soon badge. */}
      {comingSoonStartDate ? (
        <ComingSoonBadge
          startDate={comingSoonStartDate}
          isRental={contentItem.isRental}
          isDetailLayout
        />
      ) : null}

      {/* Displays the leaving soon badge when coming soon is not shown. */}
      {!comingSoonStartDate && contentItem.isLeavingSoon && contentItem.end ? (
        <LeavingSoonTitle
          endDate={contentItem.end}
          isRental={contentItem.isRental}
        />
      ) : null}
    </>
  )
}

ShowPageStatus.propTypes = {
  contentItem: PropTypes.shape({
    end: PropTypes.string,
    isComingSoon: PropTypes.bool,
    isLeavingSoon: PropTypes.bool,
    isRental: PropTypes.bool,
    rating: PropTypes.shape({
      advisories: PropTypes.string,
      rating: PropTypes.string,
      ratingSystem: PropTypes.string,
      reason: PropTypes.string
    }),
    start: PropTypes.string,
    seasons: PropTypes.arrayOf(PropTypes.shape({
      isComingSoon: PropTypes.bool,
      start: PropTypes.string
    }))
  }).isRequired,
  badges: PropTypes.arrayOf(PropTypes.string)
}

ShowPageStatus.defaultProps = {
  badges: []
}

export default ShowPageStatus
